export default {
    workOrder_trackerTab_workOrderNumber: "Nº Orden de Trabajo",
    workOrder_trackerTab_scheduledDate: "Fecha de Programación",
    workOrder_trackerTab_customer: "Cliente",
    workOrder_trackerTab_status: "Estado",
    workOrder_trackerTab_statusUpdatedOn: "Fecha de Actualización",
    workOrder_trackerTab_address: "Dirección",
    workOrder_trackerTab_type: "Tipo",
    workOrder_trackerTab_duration: "Duración (minutos)",
    workOrder_trackerTab_severity: "Severidad",
    workOrder_trackerTab_changeStatus: "Cambiar Estado",
    workOrder_trackerTab_viewAnswer: "Ver respuesta",
    workOrder_trackerTab_arrivalTime: "Hora de Llegada",
    workOrder_trackerTab_departureTime: "Hora de Salida",
    workOrder_trackerTab_noUnit: "Sin Unidad Asignada",
    workOrder_trackerTab_customer_name: "Nombre del Cliente",
    workOrder_trackerTab_contact_name: "Nombre del Contacto",
    workOrder_trackerTab_driver: "Conductor",
    workOrder_trackerTab_date: "Fecha",
    search_workOrder_trackerTab: "Buscar por Nombre del Conductor, Número de Orden de Trabajo, Nombre del Cliente, Nombre del Contacto | email | teléfono, descripción"
};